import { css } from 'styled-components';
import { Breakpoint, breakpoints } from '../breakpoints';

const diffDesktop = Breakpoint.max - Breakpoint.lg;

const responsiveFontSize = css`
  ${breakpoints.lg} {
    html {
      font-size: calc(
        13px + 3 * ((100vw - ${Breakpoint.lg}px) / ${diffDesktop})
      );
    }
  }
  ${breakpoints.max} {
    html {
      font-size: 100%;
    }
  }
`;
export default responsiveFontSize;
